/**************************************************************************
 *
 THIS MODULE IS DEPRECATED

 For requests, use requests2 / ua-requests instead:

 ui/lib/modules/request2/index.js
 ui/lib/modules/request2/ua-request.js
 *
 *************************************************************************/

var qs = require('querystring').stringify

var XHRStream = require('./xhrstream'),
  cookie = require('../utils/cookie')

var zones = []

var csrf_safe = ['GET', 'HEAD', 'OPTIONS', 'TRACE']

function to_header(key) {
  return key
    .split('-')
    .map(function(chunk) {
      return chunk.charAt(0).toUpperCase() + chunk.slice(1)
    })
    .join('-')
}

function parse_headers(response_headers) {
  response_headers = response_headers
    .split('\r\n')
    .map(function(header) {
      var bits = header.split(': '),
        header = bits[0],
        value = bits.slice(1).join(': ')

      return [header, value]
    })
    .reduce(function(lhs, rhs) {
      if (rhs[0].length) {
        lhs[rhs[0]] = lhs[rhs[0]] ? [lhs[rhs[0]], rhs[1]].join(', ') : rhs[1]
      }
      return lhs
    }, {})

  return response_headers
}

function request(method, path, headers, body, ready, preOpen) {
  var xhr = new XMLHttpRequest(),
    zone

  if (preOpen) {
    preOpen(xhr)
  }

  if (typeof headers === 'function') {
    ready = headers
    headers = {}
  } else if (typeof body === 'function') {
    ready = body
    body = null
  }

  headers = headers || {}
  headers['Accept'] = headers['Accept'] || 'application/json'

  // if you don't pass a ready function...
  if (!ready) {
    return new XHRStream(request, method, path, headers, body)
  }

  zone = zones.filter(function(zone) {
    return zone[0].test(path)
  })[0]

  if (zone && !('x-UA-keymaster-digest' in headers)) {
    zone[1](on_km_authenticated)

    return xhr
  }

  start_request(xhr, method, path, headers, body, ready)

  return xhr

  function on_km_authenticated(err, data) {
    if (err) {
      return ready(err)
    }

    for (var key in data) {
      headers[key] = data[key]
    }

    // add the v3 Accept header for protected requests.
    headers.Accept =
      headers.Accept + ', application/vnd.urbanairship+json; version=3'

    start_request(xhr, method, path, headers, body, ready)
  }
}

function start_request(xhr, method, path, headers, body, ready) {
  // the window.FormData and window.Blob checks are here to make sure this
  // doesn't break in environments (tests mainly) that do not have these
  // features.
  var not_form_data = !(window.FormData && body instanceof FormData),
    not_blob = !(window.Blob && body instanceof Blob),
    body_is_object = body && typeof body === 'object' && not_blob

  var csrf_index = Object.keys(headers)
    .map(to_lower)
    .indexOf('x-csrftoken')

  if (csrf_safe.indexOf(method) === -1 && same_origin(path)) {
    if (csrf_index === -1) {
      headers['X-CSRFToken'] = cookie('csrftoken')
    }
  }

  if (!headers['content-type'] && body_is_object && not_form_data) {
    headers['content-type'] = 'application/json'
  }

  headers['x-requested-with'] = 'XMLHttpRequest'

  xhr.open(method, path)

  for (var key in headers) xhr.setRequestHeader(to_header(key), headers[key])

  xhr.onreadystatechange = function() {
    if (xhr.readyState !== 4) {
      return
    }

    var response_headers, parsed

    var is_json =
      /json/.test(xhr.getResponseHeader('Content-Type')) ||
      /json/.test(xhr.getResponseHeader('content-type'))

    try {
      if (xhr.status < 200 || xhr.status > 299) {
        throw new Error(
          [
            'xhr ',
            xhr.statusText,
            '(' + method + ': [' + xhr.status + '] ' + path + ')'
          ].join(' ')
        )
      }

      response_headers = parse_headers(xhr.getAllResponseHeaders())

      parsed = xhr.responseType
        ? xhr.response
        : is_json
        ? JSON.parse(xhr.responseText)
        : xhr.responseText
    } catch (e) {
      e.xhr = xhr
      e.method = method
      e.path = path
      e.request_headers = headers
      e.body = body

      return ready(e)
    }

    ready(null, parsed, response_headers)
  }

  if (body_is_object && not_form_data) {
    body =
      headers['content-type'] === 'application/json'
        ? JSON.stringify(body)
        : qs(body)
  }

  xhr.send(body || null)

  return xhr
}

function to_lower(str) {
  return str.toLowerCase()
}

;['GET', 'POST', 'PUT', 'DELETE', 'HEAD', 'OPTIONS'].forEach(function(method) {
  request[method.toLowerCase()] = request.bind(null, method)
})

request.link = function(link) {
  return link
    .split(',')
    .map(function(relation) {
      return relation.split(/;\s*/)
    })
    .reduce(function(lhs, rhs) {
      var link = rhs[0].slice(1, -1),
        rel = rhs[1].split('=')

      if (rel[0] === 'rel') {
        rel[1] = /['"]/.test(rel[1].charAt(0)) ? rel[1].slice(1, -1) : rel[1]

        lhs[rel[1]] = link
      }

      return lhs
    }, {})
}

request.protect = function(path_rex, with_zone) {
  zones.push([path_rex, with_zone])
}

request.as = function(type) {
  var args = [].slice.call(arguments, 1),
    xhr = request.apply(null, args)

  xhr.addEventListener('readystatechange', set_type)
  set_type()

  return xhr

  function set_type() {
    if (xhr.readyState === 1) {
      xhr.responseType = type
    }
  }
}

function same_origin(url) {
  var host = window.location.host,
    protocol = window.location.protocol,
    sr_origin = '//' + host,
    origin = protocol + sr_origin

  var is_origin =
      url === origin || url.slice(0, origin.length + 1) === origin + '/',
    is_sr_origin =
      url === sr_origin ||
      url.slice(0, sr_origin.length + 1) === sr_origin + '/',
    not_sr_or_scheme = !/^(\/\/|http:|https:).*/.test(url)

  return is_origin || is_sr_origin || not_sr_or_scheme
}

module.exports = request
